import { toast } from 'sonner';
import { logout as apiLogout } from '../../utils/api';
import { clearToken } from '../../utils/tokenManager';
import { checkPaymentStatus } from './dashboardApi';
import logger from '../../utils/logger';

export const pollPaymentStatusUtil = async (sessionId, loadDashboardData, setShowSuccessModal, attempts = 0) => {
  if (attempts >= 5) {
    toast.error('Payment status check timed out. Please refresh the page.');
    return;
  }
  try {
    const data = await checkPaymentStatus(sessionId);
    if (data.payment_status === 'paid') {
      setShowSuccessModal(true);
      window.history.replaceState({}, document.title, '/dashboard');
      loadDashboardData();
      return;
    } else if (data.status === 'expired') {
      toast.error('Payment session expired. Please try again.');
      window.history.replaceState({}, document.title, '/dashboard');
      return;
    }
    if (attempts === 0) toast.info('Processing payment...');
    setTimeout(() => pollPaymentStatusUtil(sessionId, loadDashboardData, setShowSuccessModal, attempts + 1), 2000);
  } catch (err) {
    logger.error(err);
    toast.error('Error checking payment status. Please refresh the page.');
  }
};

export const handleLogout = async () => {
  try { await apiLogout(); } catch (err) { logger.error(err); clearToken(); window.location.href = '/'; }
};
